module.exports = __webpack_public_path__ + "img/adrian-testimonial.a88982ed.png";